'use strict';

const {Store, Reducers} = require('./lib/Reducers');
const Actions = require('./lib/Actions');

module.exports = {
  Store,
  setLevel: Actions.setLevel,
  setChapter: Actions.setChapter,
  setCollapse: Actions.setCollapse,
  cscqSelectOption: Actions.cscqSelectOption,
  cscqSubmit: Actions.cscqSubmit,
  mscqSelectOption: Actions.mscqSelectOption,
  mscqSubmit: Actions.mscqSubmit,
  gdndqSetSequence: Actions.gdndqSetSequence,
  gdndqSubmit: Actions.gdndqSubmit,
  dndqSetSequence: Actions.dndqSetSequence,
  dndqSubmit: Actions.dndqSubmit,
  ddqSetOption: Actions.ddqSetOption,
  ddqSubmit: Actions.ddqSubmit,
  setDesignTab: Actions.setDesignTab,
  viewThreeDrop: Actions.viewThreeDrop,
  viewThreeSetStep: Actions.viewThreeSetStep,
  viewThreeRemoveStep: Actions.viewThreeRemoveStep,
  viewThreeHint: Actions.viewThreeHint,
  viewFourDrop: Actions.viewFourDrop,
  viewFourSetStep: Actions.viewFourSetStep,
  viewFourRemoveStep: Actions.viewFourRemoveStep,
  viewFourHint: Actions.viewFourHint,
  viewThreeComplete: Actions.viewThreeComplete,
  viewFourComplete: Actions.viewFourComplete,
  startTour: Actions.startTour,
  incrementTour: Actions.incrementTour,
  endTour: Actions.endTour,
  setModal: Actions.setModal,
  showModal: Actions.showModal,
  undoModal: Actions.undoModal,

  // Reducers
  LevelReducer: Reducers.LevelReducer,
  NotebookReducer: Reducers.NotebookReducer,
  CSCQReducer: Reducers.CSCQReducer,
  MSCQReducer: Reducers.MSCQReducer,
  GDNDQReducer: Reducers.GDNDQReducer,
  DNDQReducer: Reducers.DNDQReducer,
  DDQReducer: Reducers.DDQReducer,
  DesignReducer: Reducers.DesignReducerNew,
  ViewThreeReducer: Reducers.ViewThreeReducer,
  ViewFourReducer: Reducers.ViewFourReducer,
  PageTourReducer: Reducers.PageTourReducer,
  MenuListReducer: Reducers.MenuListReducer,
  NotebookDrawerReducer: Reducers.NotebookDrawerReducer,
  NotebookDataReducer: Reducers.NotebookDataReducer,
  ShowLevelSelectorReducer: Reducers.ShowLevelSelectorReducer,
  TourReducer: Reducers.TourReducer,
  CSCQReducerNew: Reducers.CSCQReducerNew,
};
